import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { d: "M20.25 4.83984L19.1603 3.75009L12 10.9103L4.83975 3.75009L3.75 4.83984L10.9102 12.0001L3.75 19.1603L4.83975 20.2501L12 13.0898L19.1603 20.2501L20.25 19.1603L13.0897 12.0001L20.25 4.83984Z" }), // eslint-disable-line
'Close');
